import { defineMessages } from 'react-intl';

export default defineMessages({
    overlayText: {
        id: '_.overlay.error.text',
        defaultMessage: `Unfortunately our servers are not responding at the moment. 
        Try again now to see if that helps, otherwise give it another go in a few minutes. 
        We’re notified about all errors so we’ll be working hard to fix it.`
    },

    overlayTitle: {
        id: 'Oops, there was an error',
        defaultMessage: `Sorry, we've got an error`
    },

    overlaySubmitButton: {
        id: 'Try again',
        defaultMessage: 'Try again'
    }
});
